import { createContext, useState, useContext, useEffect } from "react";
import { useAuth as useOidcAuth } from "react-oidc-context";

const AuthContextAccess = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);
  const auth = useOidcAuth();

  useEffect(() => {
    const storedToken = localStorage.getItem("accessToken");
    if (storedToken) {
      setAccessToken(storedToken);
    }
  }, []);

  useEffect(() => {
    if (!auth.isLoading) {
      if (auth.isAuthenticated && auth.user?.access_token) {
        const token = auth.user.access_token;
        setAccessToken(token);
        localStorage.setItem("accessToken", token);
      } else if (!auth.isAuthenticated) {
        setAccessToken(null);
        localStorage.removeItem("accessToken");
      }
    }
  }, [auth.isAuthenticated, auth.user, auth.isLoading]);

  const clearToken = () => {
    setAccessToken(null);
    localStorage.removeItem("accessToken");
  };

  const value = {
    accessToken,
    setAccessToken,
    clearToken,
    isAuthenticated: auth.isAuthenticated,
    isLoading: auth.isLoading,
  };

  return <AuthContextAccess.Provider value={value}>{children}</AuthContextAccess.Provider>;
};

export const useAuthToken = () => {
  const context = useContext(AuthContextAccess);
  if (!context) {
    throw new Error("useAuthToken must be used within an AuthProvider");
  }
  return context;
};
